import TestInfo from '../../../../../../../../Models/TestInfo';
import TestSelectionFormFieldNames from '../../../../../../Models/TestSelectionFormFieldNames';
import BaseTestCard from '../BaseTestCard/BaseTestCard';
import { PreviewQuestionsProps } from '../PreviewQuestions/Dialog/usePreviewQuestions';
import { resourceBaseUrl } from '@/AppSettings';

interface SkillsTestCardProps extends Omit<PreviewQuestionsProps, 'testType'> {
    test: TestInfo;
}

function SkillsTestCard({ test, demoQuestions, likertOptions }: SkillsTestCardProps) {
    return (
        <BaseTestCard
            {...test}
            testName={test.jobFunctionName}
            fieldName={TestSelectionFormFieldNames.isSkillsSelected}
            imageURL={`${resourceBaseUrl}/images/Skills.png`}
            demoQuestions={demoQuestions}
            likertOptions={likertOptions}
        />
    );
}

export default SkillsTestCard;
